export default __webpack_public_path__ + "assets/images/1.804c0a.webp";